/*
 * Where companies live.
 *
 *   /companies                     the list (Import, New company)
 *   /companies/review              proposed companies from existing employers (firm admins)
 *   /companies/:id                 a company (Overview)
 *   /companies/:id?tab=employees   a company tab
 */
export const COMPANIES_PATH = "/companies";
export const COMPANIES_REVIEW_PATH = "/companies/review";

export const COMPANY_TABS = [
  "overview",
  "employees",
  "playbook",
  "contacts",
  "billing"
] as const;
export type CompanyTab = (typeof COMPANY_TABS)[number];

export const asCompanyTab = (v: unknown): CompanyTab =>
  typeof v === "string" && (COMPANY_TABS as readonly string[]).includes(v)
    ? (v as CompanyTab)
    : "overview";

export const companyPath = (id: string, tab?: CompanyTab): string =>
  tab && tab !== "overview"
    ? `${COMPANIES_PATH}/${id}?tab=${tab}`
    : `${COMPANIES_PATH}/${id}`;
